import { GetTokenSilentlyOptions } from '@auth0/auth0-spa-js'

type GetAccessTokenFn = (options?: GetTokenSilentlyOptions) => Promise<string>

let resolveGetter: (fn: GetAccessTokenFn) => void
let getterPromise = new Promise<GetAccessTokenFn>((resolve) => {
  // eslint-disable-next-line fp/no-mutation
  resolveGetter = resolve
})

// Called once from useSession to bridge Auth0Provider's context into non-React code.
export let setAccessTokenGetter = (fn: GetAccessTokenFn) => {
  resolveGetter(fn)
}

export let getTokens = async () => {
  let getAccessToken = await getterPromise
  let accessToken = await getAccessToken({
    authorizationParams: {
      audience: import.meta.env.VITE_AUTH0_AUDIENCE,
    },
  })
  return { accessToken }
}
